<template>
<div>
  <div class="page  covid">
    

    <div id="about" class="inner inner2">
      <h1>Covid-19 Notice</h1>
      <p>Please review our current Covid-19 information:</p> 
      <ul>
        <li><a href="/pdfs/Visitor's Guide - Copse Corner - v01.pdf">Visitor's Guide</a></li>
        <li><a href="/pdfs/Risk Assessment - Copse Corner - v01.pdf">Risk Assessment</a></li>
        <li><a href="/pdfs/Covid-19 Waiver - Copse Corner - v01.pdf">Waiver Form</a></li>
      </ul>
      
    </div>
   </div>
</div>
</template>

<script>


export default {
  name: 'new2019',
  data: function(){
    return {
      read_more: false,
    }
  }

}
</script>

<style scoped lang="scss">

.covid{

  display: block;
  align-items: flex-start;
  justify-content: flex-start;
  background-color:black;
  // background-position-x: right;
  // background-repeat: no-repeat;
  // background-position-y: center;
  // background-size: auto 100%; 
  min-height: 20vh;
  text-align: left;
  .inner2{
    background-color: rgba(0,0,0,0.6);
    border-radius: 20px;
    max-width: 1200px;
    font-size:large;
    // max-width: 600px;


    // padding:0 5%;

    h1{
      color: orange;
    }

  }
  a{
    color: orange;
    &:hover{
      color: rgb(243, 190, 93);
    }
  }
}

.extended{
  background-color: rgb(31, 31, 31);
  padding: 1em;

}

</style>
